export type CsvRowValue = string | number | boolean | null | undefined;

const formatCsvCell = (value: unknown): string => {
  if (value === null || value === undefined || value === "") return "-";
  const str = String(value);
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

const buildCsvContent = (headers: string[], rows: CsvRowValue[][]): string => {
  const lines = [
    headers.map(formatCsvCell).join(","),
    ...rows.map((row) => row.map(formatCsvCell).join(",")),
  ];
  return lines.join("\r\n");
};

const triggerCsvDownload = (content: string, filename: string) => {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  try {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename.toLowerCase().endsWith(".csv")
      ? filename
      : `${filename}.csv`;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
};

const waitForNextPaint = () =>
  new Promise<void>((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => resolve());
    });
  });

/**
 * Builds a CSV from in-memory rows and saves it. Waits a paint first so the
 * caller's download spinner renders before the (synchronous) CSV build.
 */
export const downloadLocalCsv = async (
  headers: string[],
  rows: CsvRowValue[][],
  filename: string,
): Promise<void> => {
  await waitForNextPaint();
  if (rows.length === 0) return;

  triggerCsvDownload(buildCsvContent(headers, rows), filename);
};
